import { InsightsPageTemplate } from "@/components/templates/InsightsPageTemplate";
import { aiAdsCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = aiAdsCluster.insightPages.find(p => p.slug === "ai-vs-manual-ad-optimization")!;
const relatedMoney = getRelatedMoneyPages("ai-ads").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("ai-ads").map(p => ({ title: p.title, slug: p.slug }));

export default function AIVsManualAdOptimizationPage() {
  return (
    <InsightsPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
